import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Recipe} from '../types'

export const MaterialsRecipesQueryKey = 'materialsRecipes'

export const materialsRecipesQueryOptions = (plantCode: string, assetType?: string) => ({
  queryKey: [MaterialsRecipesQueryKey, plantCode, assetType] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const params = assetType ? {assetType} : undefined
    const response = await ApiClient.axiosInstance.get<Recipe[]>(
      `/plants/${plantCode}/materials/recipes`,
      {params, signal}
    )
    return response.data
  }
})

type Params<TReturn = Recipe[]> = {
  plantCode: string
  assetType?: string
  options?: Omit<UseQueryOptions<Recipe[], AxiosError, TReturn>, 'queryKey' | 'queryFn'>
}

export const useMaterialsRecipes = <TReturn = Recipe[]>({
  plantCode,
  assetType,
  options
}: Params<TReturn>) =>
  useQuery<Recipe[], AxiosError, TReturn>({
    ...materialsRecipesQueryOptions(plantCode, assetType),
    ...options
  })
